import ModalWrapper from "../Components/Vehicle/ModalWrapper.vue";

export default {
    props: {
        locationId: {
            type: Number
        },
        isCorporate: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        hasImage() {
            return !lodash.isEmpty(this.item.images);
        },

        hasDiscountPrice() {
            if (this.hasVehicleDataProp) {
                return !lodash.isNil(this.vehicleData.discount_price)
            }

            return !lodash.isNil(this.item.discount_price)
        }
    },

    methods: {
        handleClickRentVehicle(newTab) {
            this.handleGA4AddToCart();

            let baseUrl = `/reserveren`;

            if(this.isBusiness) {
                baseUrl = baseUrl.concat(`/zakelijk`);
            }

            if (lodash.isNil(this.locationId)) {
                window.location = baseUrl + `?vehicleId=${this.item.id}&vehicleWrapperId=${this.item.vehicle_wrapper_id}`;
                return;
            }

            baseUrl = baseUrl + `?vehicleId=${this.item.id}&vehicleWrapperId=${this.item.vehicle_wrapper_id}&locationId=${this.locationId}`;

            if(newTab) {
                window.open(baseUrl);
                return;
            }

            window.location = baseUrl;
        },

        handleModal() {
            this.$modal.show(ModalWrapper, {
                props: {
                    id: this.id,
                    item: this.item,
                    locationId: this.locationId,
                    isBusiness: this.isBusiness,
                    vatPercentage: this.vatPercentage,
                    iframe: this.iframe,
                },
                label: `${window.Drupal.t('Vehicle')} modal ${this.item.title}`,
                transition: 'fade',
            });

        }
    }
}
